import '.g{display:grid;}.ssr-plugin'
import '.f{gap:1.5rem;}.ssr-plugin'
import '.gj{grid-template-columns:repeat(2, minmax(250px, 1fr));}.ssr-plugin'
import { useTranslations } from '@i18n/useLanguage'
import { SectionHeader } from '@app/components/blocks/sectionHeader/SectionHeader'
import Row from '@app/components/layout/Row'
import { CtaCard } from '@app/components/blocks/card/CtaCard'
import signup from '@app/assets/images/signup.png'
import Column from '@app/components/layout/Column'
import { Statistic } from '@app/components/blocks/statistic/Statistic'
import nutScrew from '@app/assets/images/nut_screw.svg'
import fourLeafClover from '@app/assets/images/four_leaf_clover.svg'
import tree from '@app/assets/images/tree.svg'
import leavesStacked from '@app/assets/images/leaves_stacked.svg'
import startAnInitiative from '@app/assets/images/start-initiative.png'
import { useAuthState, useQuery } from '@based/sdk/react'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { useAuthModal } from '@app/util/hooks/useAuthModal'
import { styled } from 'inlines'
import { useState } from 'react'
import { Modal } from '@app/components/blocks/modal/Modal'

interface MarketingStat {
  id: string
  title: string
  subtitle: string
  illustration: string
}

export const StatsAndCtaSection = () => {
  const translations = useTranslations().app
  const t = translations.landingPage
  const [, navigate] = useLocation()
  const auth = useAuthState()
  const { showAuthModal, withAuthCheck } = useAuthModal()
  const [profileModalOpen, setProfileModalOpen] = useState(false)

  const query = useQuery('list-landing-marketing-stats')
  const marketingStats: MarketingStat[] = query.data ?? []

  // Helper function to get illustration URL
  const getIllustrationUrl = (illustration: string) => {
    const illustrationMap: { [key: string]: string } = {
      'nut_screw.svg': nutScrew,
      'four_leaf_clover.svg': fourLeafClover,
      'tree.svg': tree,
      'leaves_stacked.svg': leavesStacked,
    }
    return illustrationMap[illustration] || nutScrew
  }

  // Helper function to get subtitle text (handles multilingual)
  const getSubtitle = (stat: MarketingStat) => {
    if (!stat.subtitle) {
      return 'Statistic'
    }
    return stat.subtitle
  }

  return (
    <>
      <Column alignItems="stretch">
        <SectionHeader
          title={t.statsAndCtaSection.title}
          subtitle={t.statsAndCtaSection.subTitle}
        />
        <Row gap="1.5rem" style={{ flexWrap: 'wrap' }}>
          <styled.div className="g f gj"
            style={{
              '@media (max-width: 1200px)': {
                gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
              },
            }}
          >
            <CtaCard
              border={true}
              title={t.statsAndCtaSection.cta[0].title}
              illustration={startAnInitiative}
              onClick={() => {
                void withAuthCheck(() => {
                  navigate(pages.dashboardInitiatives)
                  return Promise.resolve()
                })
              }}
            />
            <CtaCard
              border={true}
              title={t.statsAndCtaSection.cta[1].title}
              illustration={signup}
              onClick={
                auth.userId
                  ? () => setProfileModalOpen(true)
                  : () => showAuthModal('signUp')
              }
            />
          </styled.div>
          <Column
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '1rem',
              minWidth: '20rem',
            }}
          >
            {marketingStats.length > 0
              ? marketingStats.map((stat) => (
                  <Statistic
                    key={stat.id}
                    number={stat.title}
                    subtitle={getSubtitle(stat)}
                    illustration={getIllustrationUrl(stat.illustration)}
                  />
                ))
              : // Fallback to static data if no database stats available
                t.statsAndCtaSection.statistics.map((statistic, index) => (
                  <Statistic
                    key={index}
                    number={statistic.number}
                    subtitle={statistic.subtitle}
                    illustration={nutScrew} // Default illustration for fallback
                  />
                ))}
          </Column>
        </Row>
      </Column>
      <Modal
        title={translations.auth.signUp}
        isOpen={profileModalOpen}
        onClose={() => setProfileModalOpen(false)}
      >
        {translations.auth.alreadyLoggedIn}
      </Modal>
    </>
  )
}
